
import { systemCode, xs_languageCode } from "../..";

/*
export function getUrlPathSeoSettings(data) {
    try {
        const seoSettings = data && data.seoSettings?JSON.parse(data.seoSettings):null;
        const seoSettingSysCodeLang = seoSettings && (seoSettings[systemCode]?seoSettings[systemCode]:seoSettings['DEFAULT'])?.[xs_languageCode];
        return seoSettingSysCodeLang;
    } catch(err) {
        console.log(err);
    }

    return null;
}
*/

export function getUrlPathSeoSettings(data) {
    try {
        const seoSettingsAdds = data && data.seoSettingsAdds?JSON.parse(data.seoSettingsAdds):null;
        const seoSettingAddsByDefault =   seoSettingsAdds && (seoSettingsAdds['DEFAULT'])?.[xs_languageCode];
        const seoSettingAddsBySysCode  =   seoSettingsAdds && (seoSettingsAdds[systemCode])?.[xs_languageCode];
        return (seoSettingAddsBySysCode && Object.keys(seoSettingAddsBySysCode).length > 0)?seoSettingAddsBySysCode:seoSettingAddsByDefault;
    } catch(err) {
        console.error(err);
    }

    return null;
}
